import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Divider, Grid, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useState } from "react";
import { countryRequest } from "../../../api/CountryRequest";

interface Props {
  open: boolean;
  onClose: AnyFunction;
  country?: Country;
  onCountryEdited: AnyFunction;
}

interface FormValues {
  name: string;
}

export default function EditCountryDialog(props: Props) {
  const { open, onClose, country, onCountryEdited } = props;

  const [formValues, setFormValues] = useState<FormValues>({
    name: "",
  });

  const [error, setError] = useState({
    name: false,
    nameIsDuplicate: false,
  });

  const [countryData, setCountryData] = useState<Country[]>([]);

  const fetchCountries = () => {
    countryRequest
      .getCountries()
      .then((countries) => setCountryData(countries));
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const checkNameIsDuplicate = (country: Country) =>
    country.name?.toLowerCase() === formValues.name?.toLowerCase();

  const handleErrors = () => {
    if (!formValues.name) {
      setError((prev: any) => ({
        ...prev,
        name: true,
      }));
    } else if (formValues.name) {
      setError((prev: any) => ({
        ...prev,
        name: false,
      }));
    }
    if (formValues.name === country?.name) {
      setError((prev: any) => ({
        ...prev,
        nameIsDuplicate: false,
      }));
    } else if (formValues.name !== country?.name) {
      setError((prev: any) => ({
        ...prev,
        nameIsDuplicate: countryData.some(checkNameIsDuplicate),
      }));
    }
  };

  const handleSubmit = () => {
    if (country && country.id) {
      handleErrors();
      const nameCondition =
        formValues.name === country?.name ||
        !countryData.some(checkNameIsDuplicate);
      const formIsValid = formValues.name && nameCondition;
      if (formIsValid) {
        return countryRequest
          .updateCountry(country.id, formValues)
          .then(() => {
            if (typeof onCountryEdited === "function") {
              onCountryEdited();
            }
          })
          .catch(() => {
            alert("S-a produs o eroare!");
          });
      }
    }
  };

  const handleCloseEditCargoTypeDialog = () => {
    onClose();
    setError(() => ({
      name: false,
      nameIsDuplicate: false,
    }));
  };

  useEffect(() => {
    if (country && country.name) {
      setFormValues({ name: country.name });
    }
  }, [country]);

  return (
    <>
      <Dialog open={open} fullWidth maxWidth="xs">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <DialogTitle sx={{ pb: 0 }}>Modificare tip marfă</DialogTitle>
          </Grid>
          <Grid item sx={{ mr: 2, pt: 2 }}>
            <IconButton onClick={handleCloseEditCargoTypeDialog} tabIndex={-1}>
              <ClearIcon />
            </IconButton>
          </Grid>
        </Grid>
        <DialogContent>
          <TextField
            required
            size="small"
            fullWidth
            label="Nume"
            error={error.name || error.nameIsDuplicate}
            helperText={
              error.name
                ? "Câmp obligatoriu!"
                : error.nameIsDuplicate && "Nume deja existent!"
            }
            value={formValues?.name ?? ""}
            onChange={(event) =>
              setFormValues((prev: any) => ({
                ...prev,
                name: event.target.value.toUpperCase(),
              }))
            }
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                handleSubmit()
                  ?.then(handleCloseEditCargoTypeDialog)
                  .then(fetchCountries);
              }
            }}
            inputProps={{ style: { textTransform: "uppercase" } }}
          ></TextField>
          <Divider sx={{ mb: 2, opacity: 0 }} />
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12} md={6}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  handleSubmit()
                    ?.then(handleCloseEditCargoTypeDialog)
                    .then(fetchCountries);
                }}
              >
                Salvează
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                fullWidth
                variant="outlined"
                onClick={handleCloseEditCargoTypeDialog}
              >
                Renunță
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
